<template>
  <div class="contract-info">
    <!-- 基础信息 -->
    <div class="app-panel blank-h blank-v panel-1">
      <el-image :src="info.contract_data.attachment_access_url"></el-image>
      <div class="wrap">
        <p>客户姓名：{{info.customer_name}}</p>
        <p>签约项目：{{info.project_name}}</p>
        <p>经纪人：{{info.realtor_name}}</p>
        <p>性别：</p>
        <p>签约房间：{{info.project_chamber_name}}</p>
        <p>渠道类型：{{info.realtor_role}}</p>
        <p>手机号：{{info.customer_phone}}</p>
        <p>签约时间：{{info.contract_datetime}}</p>
        <p>渠道公司：{{info.realtor_company_name}}</p>
        <p>证件号码：{{info.contract_data.contract_customer_identity_num}}</p>
        <p>签约金额：{{info.contract_amount}}元</p>
        <p>职业顾问：{{info.user_name}}</p>
        <p>明源同步时间：{{info.created_at}}</p>
      </div>
    </div>
    <div class="app-panel blank-h blank-v panel-2" v-if="status !== 1">
      <div class="app-control">
        <span class="title">风险指标：</span>
        <el-tag v-for="(value, index) in info.label" :key="index" type="danger" size="small" :class="{'tag-link': value.value === 1}" @click="repeatInfo(value.value)">{{value.text}}<i class="el-icon-info" v-if="value.value === 1"></i></el-tag>
      </div>
    </div>
    <!-- 匹配项 -->
    <div class="app-panel blank-h blank-v panel-3">
      <p class="text">已匹配到<span>{{person.length}}位</span>疑似到访人脸识别记录</p>
      <div class="items">
        <div class="wrap" v-for="(value, index) in person" :key="index">
          <el-image :src="value.url"></el-image>
          <p>{{value.id}}</p>
        </div>
      </div>
    </div>
    <!-- 进度 -->
    <div class="app-panel blank-h blank-v">
      <el-table :data="datas" v-loading="loading">
        <el-table-column label="时间" prop="time"></el-table-column>
        <el-table-column label="客户行为" prop="textOne"></el-table-column>
        <el-table-column label="留痕抓拍">
          <template slot-scope="{row}">
            <el-image :src="row.image" v-if="row.image"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="留痕记录">
          <template slot-scope="{row}">
            <p v-for="(value, index) in row.textTwo" :key="index">{{value}}</p>
          </template>
        </el-table-column>
        <el-table-column label="相似度" v-if="status === 2">
          <template slot-scope="{row}">
            <el-tag size="small" type="info">{{row.extra.project_customer_recognition_log_similar ? row.extra.project_customer_recognition_log_similar : '--'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row, $index}">
            <el-button type="text" @click="certificationInfo(row.extra.contract_id)" v-if="row.info">详情</el-button>
            <el-button type="text" @click="reportInfo(row.extra)" v-if="row.report">详情</el-button>
            <el-button type="text" @click="delData($index)" v-if="row.del">删除</el-button>
            <el-button type="text" @click="scanLargeImage(row.extra.provide_large_attachment_data.attachment_access_url)" v-if="row.scanLargeImage">查看大图</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="app-panel blank-v" v-if="status !== 1">
      <el-timeline>
        <el-timeline-item hide-timestamp v-for="(m, n) in progressDatas" :key="n">
          <p><span>{{m.date}}</span><span>{{m.type}}</span><el-tag :type="m.state_color" size="small">{{m.state}}</el-tag><span v-for="(x, y) in m.text.split(',')" :key="y">{{x}}</span></p>
        </el-timeline-item>
      </el-timeline>
    </div>
    <!-- <div class="app-panel blank-h blank-v" v-if="status === 3">
      <el-button type="primary" @click="risk">风险判定</el-button>
    </div> -->
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center append-to-body>
      <certification-info :id="infoDialog.id" v-if="infoDialog.show"></certification-info>
    </el-drawer>
    <el-drawer :title="reportDialog.title" :visible.sync="reportDialog.show" center append-to-body>
      <report-info :info="reportDialog.info" v-if="reportDialog.show"></report-info>
    </el-drawer>
    <el-drawer :title="repeatDialog.title" :visible.sync="repeatDialog.show" center append-to-body size="80%">
      <contract-repeat-manage :initValueThree="repeatDialog.text" v-if="repeatDialog.show"></contract-repeat-manage>
    </el-drawer>
    <el-dialog :title="riskDialog.title" :visible.sync="riskDialog.show" center append-to-body>
      <el-form :label-width="labelWidth">
        <el-form-item label="风险判定">
          <el-radio-group v-model="riskDialog.valueOne">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">风险</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核结论">
          <el-input v-model="riskDialog.valueTwo" type="textarea" :rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="riskDialogSubmit">确定</el-button>
        <el-button @click="riskDialog.show = false">取消</el-button>
      </div>
    </el-dialog>
    <el-image-viewer :urlList="largeImage.value" :onClose="closeLargeImage" v-if="largeImage.show"></el-image-viewer>
  </div>
</template>

<script>
  import ContractService from '@/io/contract.js';
  import LogService from '@/io/log.js';
  import CertificationInfo from '@/views/CertificationInfo.vue';
  import ReportInfo from '@/views/ReportInfo.vue';
  import ContractRepeatManage from '@/views/ContractRepeatManage.vue';
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue';
  
  export default {
    name: 'ContractInfo',
    props: {
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        largeImage: {
          show: false,
          value: []
        },
        riskDialog: {
          title: '风险判定',
          show: false,
          valueOne: 1,
          valueTwo: ''
        },
        infoDialog: {
          title: '认证详情',
          show: false,
          id: null
        },
        reportDialog: {
          title: '报备详情',
          show: false,
          info: null
        },
        repeatDialog: {
          title: '重复签约详情',
          show: false,
          text: null
        },
        status: null,
        similarValue: 90,
        similarOptions: [
          {
            text: '人脸相似度-低',
            value: 70
          },
          {
            text: '人脸相似度-中',
            value: 80
          },
          {
            text: '人脸相似度-高',
            value: 90
          },
        ],
        options: {},
        info: {
          contract_data: {},
          label: []
        },
        period: [],
        loading: false,
        datas: [], // 表格数据
        person: [], // 识别记录 人
        progressDatas: []
      }
    },
    components: {
      CertificationInfo,
      ReportInfo,
      ContractRepeatManage,
      ElImageViewer
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initOptions().then(() => {
              this.initDatas();
            }).catch(() => {});
          }
        },
        immediate: true
      }
    },
    methods: {
      scanLargeImage(src) {
        this.setWaterMark('本图片仅用于视频监控', `${this.$store.state.userInfo.account_attr_data.account_attr_name}`);
        this.largeImage.value = [src];
        this.largeImage.show = true;
      },
      closeLargeImage() {
        this.removeWatermark();
        this.largeImage.value = [];
        this.largeImage.show = false;
      },
      setRisk() {
        this.$confirm(
          '确认设为风险?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ContractService.setRisk(this.id);
        }).then(res => {
          this.initDatas();
        }).catch(() => {});
      },
      risk() {
        this.riskDialog.show = true;
      },
      search() {
        let datas = [];
        this.datas.forEach(val => {
          if (!val.extra.project_customer_recognition_log_id) {
            datas.push(val);
          }
        });
        this.datas = datas;
        this.formatDatas();
      },
      riskDialogSubmit() {
        let ids = [];
        this.datas.forEach(val => {
          let id = val.extra.project_customer_recognition_log_id;
          if (id) {
            ids.push(id);
          }  
        });
        ContractService.risk(this.id, ids, this.riskDialog.valueOne, this.riskDialog.valueTwo).then(() => {
          this.initDatas();
          this.riskDialog.show = false;
        }).catch(() => {});
      },
      certificationInfo(id) {
        this.infoDialog.show = true;
        this.infoDialog.id = id;
      },
      reportInfo(info) {
        this.reportDialog.show = true;
        this.reportDialog.info = info;
      },
      repeatInfo(id) {
        if (id === 1) {
          this.repeatDialog.show = true;
          this.repeatDialog.text = this.info.project_chamber_name;
        }
      },
      initOptions() {
        return ContractService.searchParam().then(res => {
          this.options = res.data;
        }).catch(() => {});
      },
      initDatas() {
        ContractService.info(this.id).then(res => {
          this.status = res.data.customer_transaction_history_handle_state;
          // 初始化信息数据
          this.options.realtor_roles.forEach(m => {
            if (m.value === res.data.realtor_role) {
              res.data.realtor_role = m.text;
            }
          });
          let label = [];
          JSON.parse(res.data.risk_signing_types).forEach(val => {
            this.options.risk_signing_type.forEach(m => {
              if (m.value === val) {
                label.push(m);
              }
            });
          });
          this.progressDatas = res.data.risk_sign_handle_data.map(val => {
            if (!val.text) {
              val.text = '';
            }
            return val;
          });
          this.info = {
            ...res.data,
            label
          }
          // 初始化表格数据
          let datas = [];
          if (res.data.contract_id) {
            datas.push({
              time: res.data.contract_data.contract_date,
              textOne: '客户认证',
              image: res.data.contract_data.attachment_access_url,
              textTwo: [res.data.contract_data.contract_type === 1 ? '认证方式：一体机' : '认证方式：小程序'],
              info: true,
              extra: res.data
            });
          }
          if (res.data.reporting_datetime) {
            datas.push({
              time: res.data.reporting_datetime,
              textOne: '客户报备',
              image: null,
              textTwo: [`经纪人：${res.data.realtor_name}`, `经纪人电话：${res.data.realtor_phone}`, `渠道类型：${res.data.realtor_role}`],
              report: true,
              extra: res.data
            });
          }
          this.datas = datas;
          this.formatDatas();
          // 初始化表格剩余数据
          this.person = [{
            id: res.data.project_customer_data.project_customer_open_id,
            url: res.data.project_customer_data.face_data[0].attachment_data.attachment_access_url
          }];
          this.datas = this.datas.concat(this.formatPersonDatas(res.data.recognition_data));
          this.formatDatas();
        }).catch(() => {})
      },
      formatDatas() {
        this.datas = this.createNewVariable(this.datas.sort((a, b) => new Date(a.time) > new Date(b.time) ? -1 : 1));
      },
      formatPersonDatas(datas) {
        return datas.map(val => {
          return {
            id: val.project_customer_recognition_log_id,
            time: val.project_customer_recognition_log_recognition_at,
            textOne: '客户到访',
            image: val.provide_attachment_data.attachment_access_url,
            textTwo: [`抓拍位置：${val.project_customer_recognition_log_location_name}`, `人脸编号：${val.project_customer_open_id}`],
            extra: val,
            scanLargeImage: true
          }
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .contract-info {
    .app-panel {
      &.panel-1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-image {
          width: 160px;
          height: 160px;
          margin-right: 10px;
          border-radius: 50%;
        }
        .wrap {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          p {
            width: calc((100% - 60px) / 3);
            margin: 8px;
            .text-overflow;
          }
        }
      }
      &.panel-2 {
        .title {
          width: 100px;
          text-align: right;
        }
      }
      &.panel-3 {
        overflow: hidden;
        .text {
          margin-bottom: 20px;
          span {
            color: @color-danger;
            margin: 0 5px;
          }
        }
        .items {
          margin: 0 -5px;
          .wrap {
            width: calc(15% - 22px);
            float: left;
            margin: 0 5px;
            text-align: center;
            .el-image {
              width: 100px;
              height: 100px;
              margin: 0 auto 10px auto;
            }
            p {
              .text-overflow;
            }
          }
        }
      }
    }
  }
</style>